import { DialogContent } from '@mui/material';
import { styled as muiStyled, SxProps, Theme } from '@mui/material/styles';
import styled from 'styled-components';
import { colorPalette, getSpacing, typography } from 'stylesheet';

import { DialogStyleProps } from './Dialog';

export const getDialogPaperSx = ({
  widthInPercent,
  heightInPercent,
  maxWidthInPx,
  responsiveOnTablet,
}: DialogStyleProps & { responsiveOnTablet?: boolean }): SxProps<Theme> => ({
  padding: getSpacing(3),
  ...(widthInPercent
    ? {
        width: `${widthInPercent}%`,
        maxWidth: maxWidthInPx ? `${maxWidthInPx}px` : `${widthInPercent}%`,
      }
    : { minWidth: '400px', maxWidth: '800px' }),
  ...(heightInPercent
    ? { height: `${heightInPercent}%` }
    : { minHeight: '200px', maxHeight: '90%' }),
  borderRadius: getSpacing(2),

  // Responsive style only responsiveOnTablet true
  ...(responsiveOnTablet && {
    '@media (max-width: 600px)': {
      width: '47vw !important', // Tables
      maxWidth: '90vw !important',
      margin: '0 auto !important',
    },
    '@media (min-width: 1024px) and (max-width: 1280px)': {
      width: '42vw !important',
      maxWidth: '70vw !important',
    },
    '@media (max-width: 444px)': {
      width: '95vw !important', // mobile phones
      maxWidth: '95vw !important',
    },
  }),
});

export const StyledDialogContent = muiStyled(DialogContent)({
  padding: 0,
});

export const StyledDialogHeader = styled.div`
  height: ${getSpacing(8)};
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const TitleContainer = styled.div<{ $showCloseIcon: boolean }>`
  width: 100%;
  display: flex;
  justify-content: ${(props) => (props.$showCloseIcon ? 'start' : 'center')};
  ${typography.title_xsmall};
`;

const getTitleIconColor = (titleIconColor?: string) => {
  switch (titleIconColor) {
    case 'grey':
      return colorPalette.greyMain;
    case 'orange':
      return colorPalette.secondary_600;
  }
};

export const TitleIconContainer = styled.div<{ $titleIconColor?: string }>`
  width: ${getSpacing(5)};
  height: ${getSpacing(5)};
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${(props) => getTitleIconColor(props.$titleIconColor)};
  margin-right: ${getSpacing(2)};
`;
